import React from 'react';
import { Button, ButtonAsAnchorProps } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { communityNavSubHeaderDataHooks } from '../CommunityNavSubHeader.dataHooks';
import useCommunityNavSubHeaderBi, {
  ACTION_NAMES,
} from '../CommunityNavSubHeaderMobile/useCommunityNavSubHeaderBi';

interface Props {
  buttonProps?: Partial<ButtonAsAnchorProps<any>>;
  isSmallLabel?: boolean;
}

const DiscordButton = ({ buttonProps = {}, isSmallLabel }: Props) => {
  const { t } = useTranslation();
  const { reportElementsClick } = useCommunityNavSubHeaderBi();

  const labelKey = isSmallLabel
    ? 'marketplace.community-nav-sub-header.discord-label-small'
    : 'marketplace.community-nav-sub-header.discord-label';

  const label = t(labelKey);
  const link = t('marketplace.community-nav-sub-header.discord-link');

  return (
    <Button
      as="a"
      target="_blank"
      href={link}
      size="small"
      onClick={() =>
        reportElementsClick({
          actionName: ACTION_NAMES.ExternalLink,
          elementTitle: label,
          value: link,
        })
      }
      dataHook={communityNavSubHeaderDataHooks.action()}
      {...buttonProps}
    >
      {t(label)}
    </Button>
  );
};

export default DiscordButton;
